import React, { useEffect, useState } from 'react';
import OrderList from '../lists/OrderList';
import { StockOrder } from 'openapi';
import CommonContainer from "../../containers/Common";
import StockOrderContainer from "../../containers/StockOrder";

const Root = (() => {

  const commonContainer = CommonContainer.useContainer();
  const stockOrderContainer = StockOrderContainer.useContainer();

  const now = new Date();
  const utc = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());

  const [selectedDate, setSelectedDate] = React.useState<Date>(new Date(utc));
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    (handleReload)();
  }, [selectedDate]);

  const handleSelectedDateChange = (date: Date | null) => {
    if (date) {
      setSelectedDate(date);
    }
  };

  const handleOrder = async (stockOrders: StockOrder[]) => {
    setIsLoading(true);
    await stockOrderContainer.order({
      requests: stockOrders.map(stockOrder => {
        return {
          meganetLensOrderId: stockOrder.meganetLensOrderId
        }
      }),
    });
    setIsLoading(false);
  }

  const handleReload = async () => {
    setIsLoading(true);
    await commonContainer.loadMakers();
    await stockOrderContainer.load(selectedDate);
    setIsLoading(false);
  }

  const handleRemarks = async (stockOrders: StockOrder[]) => {
    setIsLoading(true);
    for (const stockOrder of stockOrders) {
      stockOrder.remarks = 'STOCK';
      stockOrder.recordedDate = selectedDate;
      await stockOrderContainer.update(stockOrder as StockOrder)
    }
    setIsLoading(false);
  }

  return (
    <OrderList
      isLoading={isLoading}
      date={selectedDate}
      onSelectedDateChange={handleSelectedDateChange}
      onOrder={handleOrder}
      onReload={handleReload}
      onRemarks={handleRemarks}
    />
  )
}) as React.FC;

export default (() => {
  return (
    <StockOrderContainer.Provider>
      <Root />
    </StockOrderContainer.Provider>
  )
}) as React.FC;
